export default __webpack_public_path__ + "static/media/reservations.fb795719.png";